var map = {
	"./bola.mp4": 9010,
	"./bow.mp4": 9568,
	"./cartao.mp4": 3752,
	"./dancing_pig.mp4": 9005,
	"./fartguy.mp4": 3558,
	"./frog.mp4": 1748,
	"./guitar_smash.mp4": 1909,
	"./heartkey.mp4": 8271,
	"./kiss.mp4": 7800,
	"./knock.mp4": 5100,
	"./laughing_girl.mp4": 5606,
	"./notes.mp4": 5095,
	"./water_balloon.mp4": 2881,
	"./yawning_moon.mp4": 4071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7574;